export default "__VITE_ASSET__DtTDQGVL__"